import { PreviewAttributeModel } from './PreviewAttribute.model';

export class PreviewAttributeArrayModel {
  EngagementId: number;
  previewDataList: PreviewAttributeModel[];
}
